/**
 * Free-shipping progress bar — keeps [data-fs-bar] in sync with the cart.
 *
 * Deliberately does not touch theme.js: it watches the DOM nodes Debut's own
 * cart modules already update ([data-cart-subtotal] on the cart page, the
 * add-to-cart popup wrapper) and re-reads /cart.js when either changes.
 * Initial state is rendered server-side by snippets/free-shipping-bar.liquid,
 * so the bar is correct even if this file never runs.
 */
(function () {
  'use strict';

  var SEL_BAR = '[data-fs-bar]';

  function bars() {
    return Array.prototype.slice.call(document.querySelectorAll(SEL_BAR));
  }

  function formatMoney(cents, format) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      try {
        return theme.Currency.formatMoney(cents, format);
      } catch (e) {
        /* fall through */
      }
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function render(bar, total) {
    var threshold = parseInt(bar.getAttribute('data-fs-threshold'), 10);
    if (!threshold || isNaN(total)) return;

    var remaining = Math.max(threshold - total, 0);
    var pct = Math.min(Math.round((total * 100) / threshold), 100);
    var reached = total >= threshold;

    var textEl = bar.querySelector('[data-fs-text]');
    var fillEl = bar.querySelector('[data-fs-fill]');

    if (fillEl) fillEl.style.width = pct + '%';
    bar.classList.toggle('free-shipping--reached', reached);

    if (!textEl) return;

    if (reached) {
      textEl.textContent = bar.getAttribute('data-fs-reached') || '';
    } else {
      var template = bar.getAttribute('data-fs-pending') || '';
      var money = formatMoney(remaining, bar.getAttribute('data-fs-money-format'));
      var parts = template.split('[importo]');
      textEl.textContent = '';
      parts.forEach(function (chunk, i) {
        textEl.appendChild(document.createTextNode(chunk));
        if (i < parts.length - 1) {
          var span = document.createElement('span');
          span.className = 'free-shipping__amount';
          span.setAttribute('data-fs-amount', '');
          span.textContent = money;
          textEl.appendChild(span);
        }
      });
    }
  }

  var pending = null;

  function refresh() {
    if (!bars().length || !window.fetch) return;
    clearTimeout(pending);
    pending = setTimeout(function () {
      fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          bars().forEach(function (bar) {
            render(bar, cart.total_price);
          });
        })
        .catch(function () {
          /* leave the server-rendered state in place */
        });
    }, 120);
  }

  function watch(node) {
    if (!node || !window.MutationObserver) return;
    new MutationObserver(refresh).observe(node, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function init() {
    if (!bars().length) return;
    // Cart page: Debut rewrites the subtotal on every AJAX quantity change.
    document.querySelectorAll('[data-cart-subtotal]').forEach(watch);
    // Add-to-cart popup: its wrapper class flips when an item is added.
    watch(document.querySelector('[data-cart-popup-wrapper]'));
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
